import { Action } from '@ngrx/store'

import { CreateRequest, CreateResponse, ResetRequest, AccountValidationResult } from '../models/account'

export const CREATE = '[Account] Create'
export const CREATE_SUCCESS = '[Account] Create Success'
export const CREATE_FAILED = '[Account] Create Failed'
export const CREATE_CLEAR = '[Account] Create Clear'

export const FORGOT = '[Account] Forgot'
export const FORGOT_SUCCESS = '[Account] Forgot Success'
export const FORGOT_FAILED = '[Account] Forgot Failed'
export const FORGOT_CLEAR = '[Account] Forgot Clear'

export const RESET = '[Account] Reset'
export const RESET_SUCCESS = '[Account] Reset Success'
export const RESET_FAILED = '[Account] Reset Failed'
export const RESET_CLEAR = '[Account] Reset Clear'

export const VALIDATE_RESET_LINK = '[Account] Validate Reset Link'
export const VALIDATE_RESET_LINK_SUCCESS = '[Account] Validate Reset Link Success'
export const VALIDATE_RESET_LINK_FAILED = '[Account] Validate Reset Link Failed'

export const ACTIVATE = '[Account] Activate'
export const ACTIVATE_SUCCESS = '[Account] Activate Success'
export const ACTIVATE_FAILED = '[Account] Activate Failed'

export const USER_GET_LANGUAGE = '[User] Get Language'
export const USER_GET_LANGUAGE_SUCCESS = '[User] Get Language Success'
export const USER_GET_LANGUAGE_FAILED = '[User] Get Language Failed'

export const USER_VERIFY_EMAIL = '[User] Verify E-mail address'
export const USER_VERIFY_EMAIL_SUCCESS = '[User] Verify E-mail address success'
export const USER_VERIFY_EMAIL_FAILED = '[User] Verify E-mail address failed'

export class Create implements Action {
    readonly type = CREATE
    constructor(public payload: CreateRequest) {}
}
export class CreateSuccess implements Action {
    readonly type = CREATE_SUCCESS
    constructor(public payload: CreateResponse) {}
}
export class CreateFailed implements Action {
    readonly type = CREATE_FAILED
    constructor(public payload: any){}
}
export class CreateClear implements Action {
    readonly type = CREATE_CLEAR
}

export class Forgot implements Action {
    readonly type = FORGOT
    constructor(public payload: string) {}
}
export class ForgotSuccess implements Action {
    readonly type = FORGOT_SUCCESS
}
export class ForgotFailed implements Action {
    readonly type = FORGOT_FAILED
    constructor(public payload: any) {}
}
export class ForgotClear implements Action {
    readonly type = FORGOT_CLEAR
}

export class Reset implements Action {
    readonly type = RESET
    constructor(public payload: ResetRequest) {}
}
export class ResetSuccess implements Action {
    readonly type = RESET_SUCCESS
}
export class ResetFailed implements Action {
    readonly type = RESET_FAILED
    constructor(public payload: any) {}
}
export class ResetClear implements Action {
    readonly type = RESET_CLEAR
}

export class ValidateResetLink implements Action {
  readonly type = VALIDATE_RESET_LINK
  constructor (public payload: string) {}
}
export class ValidateResetLinkSuccess implements Action {
  readonly type = VALIDATE_RESET_LINK_SUCCESS
  constructor (public payload: boolean) {}
}
export class ValidateResetLinkFailed implements Action {
  readonly type = VALIDATE_RESET_LINK_FAILED
  constructor (public payload: any) {}
}

export class Activate implements Action {
    readonly type = ACTIVATE
    constructor(public payload: string) {}
}
export class ActivateSuccess implements Action {
    readonly type = ACTIVATE_SUCCESS
    constructor() {}
}
export class ActivateFailed implements Action {
    readonly type = ACTIVATE_FAILED
    constructor(public payload: any) {}
}

export class UserGetLanguage implements Action {
  readonly type = USER_GET_LANGUAGE
  public constructor(public payload: string) {}
}
export class UserGetLanguageSuccess implements Action {
  readonly type = USER_GET_LANGUAGE_SUCCESS
  public constructor(public payload: string) {}
}
export class UserGetLanguageFailed implements Action {
  readonly type = USER_GET_LANGUAGE_FAILED
  public constructor(public payload: Error) {}
}

export class UserVerifyEmail implements Action {
  readonly type = USER_VERIFY_EMAIL
  public constructor(public payload: string) {}
}
export class UserVerifyEmailSuccess implements Action {
  readonly type = USER_VERIFY_EMAIL_SUCCESS
  public constructor(public payload: AccountValidationResult) {}
}
export class UserVerifyEmailFailed implements Action {
  readonly type = USER_VERIFY_EMAIL_FAILED
  public constructor(public payload: Error) {}
}

export type Actions =
    | Create
    | CreateSuccess
    | CreateFailed
    | CreateClear
    | Forgot
    | ForgotSuccess
    | ForgotFailed
    | ForgotClear
    | Reset
    | ResetSuccess
    | ResetFailed
    | ResetClear
    | ValidateResetLink
    | ValidateResetLinkSuccess
    | ValidateResetLinkFailed
    | Activate
    | ActivateSuccess
    | ActivateFailed
    | UserGetLanguage
    | UserGetLanguageSuccess
    | UserGetLanguageFailed
    | UserVerifyEmail
    | UserVerifyEmailSuccess
    | UserVerifyEmailFailed
